import { render, staticRenderFns } from "./ReceivePackge.vue?vue&type=template&id=aea8387c&scoped=true"
import script from "./ReceivePackge.vue?vue&type=script&lang=js"
export * from "./ReceivePackge.vue?vue&type=script&lang=js"
import style0 from "./ReceivePackge.vue?vue&type=style&index=0&id=aea8387c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea8387c",
  null
  
)

export default component.exports